const VEHICLE_COMMON_COLORS = [
  { label: 'Beige', value: 'beige' },
  { label: 'Blanc', value: 'blanc' },
  { label: 'Bleu', value: 'bleu' },
  { label: 'Gris', value: 'gris' },
  { label: 'Ivoire', value: 'ivoire' },
  { label: 'Marron', value: 'marron' },
  { label: 'Noir', value: 'noir' },
  { label: 'Rouge', value: 'rouge' },
  { label: 'Vert', value: 'vert' },
];

export const VEHICLE_SPECIFIC_INTERIOR_COLOR = [
  ...VEHICLE_COMMON_COLORS,
  { label: 'Fauve', value: 'fauve' },
  { label: 'Gris/Bleu', value: 'gris/bleu' },
];

export const VEHICLE_SPECIFIC_EXTERIOR_COLOR = [
  ...VEHICLE_COMMON_COLORS,
  { label: 'Gris anthracite', value: 'gris anthracite' },
  { label: 'Argent', value: 'argent' },
  { label: 'Bleu clair', value: 'bleu clair' },
  { label: 'Bleu marine', value: 'bleu marine' },
  { label: 'Bordeaux', value: 'bordeaux' },
  { label: 'Gris clair', value: 'gris clair' },
  { label: 'Gris foncé', value: 'gris foncé' },
  { label: 'Jaune', value: 'jaune' },
  { label: 'Marron clair', value: 'marron clair' },
  { label: 'Or', value: 'or' },
  { label: 'Orange', value: 'orange' },
  { label: 'Rouge foncé', value: 'rouge foncé' },
  { label: 'Rose', value: 'rose' },
  { label: 'Vert foncé', value: 'vert foncé' },
  { label: 'Violet', value: 'violet' },
  { label: 'Clair', value: 'clair' },
  { label: 'Foncé', value: 'foncé' },
];

export const VEHICLE_PAINT_TYPE = [
  { label: 'Metal', value: 'metal' },
  { label: 'Verni', value: 'verni' },
  { label: 'Mat', value: 'mat' },
  { label: 'Opaque (verni sans reflet)', value: 'opaque (verni sans reflet)' },
  { label: 'Nacre', value: 'nacre' },
];

export const VEHICLE_SEAT_MATERIAL = [
  { label: 'Velours', value: 'velours' },
  { label: 'Alcantara', value: 'alcantara' },
  { label: 'Tweed', value: 'tweed' },
  { label: 'Simili cuir', value: 'simili cuir' },
  { label: 'Cuir/alcantara', value: 'cuir/tissu' },
  { label: 'Cuir/tissu', value: 'cuir/tissu' },
  { label: 'Jean', value: 'jean' },
  { label: 'Tissu', value: 'tissu' },
  { label: 'Cuir', value: 'cuir' },
  { label: 'Drap', value: 'drap' },
];

export const getVehicleInterior = (vehicleInterior: string): Record<string, string> => {
  try {
    if (vehicleInterior) {
      for (const item of VEHICLE_SEAT_MATERIAL) {
        const seatMaterial = item.value;
        if (vehicleInterior.startsWith(seatMaterial)) {
          const internalColor = vehicleInterior.replace(seatMaterial, '').trim();
          if (VEHICLE_SPECIFIC_INTERIOR_COLOR.map(p => p.value).includes(internalColor)) {
            return { seatMaterial, internalColor };
          } else {
            return { seatMaterial, internalColor: '' };
          }
        }
      }
    }
    return { seatMaterial: '', internalColor: '' };
  } catch (_) {
    return { seatMaterial: '', internalColor: '' };
  }
};

export const getVehicleExterior = (vehicleExterior: string): Record<string, string> => {
  try {
    if (vehicleExterior) {
      for (const paintType of VEHICLE_PAINT_TYPE) {
        if (vehicleExterior.endsWith(paintType.value)) {
          const externalColor = vehicleExterior.replace(paintType.value, '').trim();
          if (VEHICLE_SPECIFIC_EXTERIOR_COLOR.map(c => c.value).includes(externalColor.toLocaleLowerCase())) {
            return { paintType: paintType.value, externalColor };
          } else {
            return { paintType: paintType.value, externalColor: '' };
          }
        }
      }
    }
    return { paintType: '', externalColor: '' };
  } catch (_) {
    return { paintType: '', externalColor: '' };
  }
};
